import { useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { Input } from "../ui/input";

const clean = (v) => v.toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/-{2,}/g, "-").slice(0, 40);

export const WebAddress = ({ profile, onChange }) => {
  const [value, setValue] = useState(profile.slug);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const host = window.location.host.replace(/^www\./, "");

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const { data } = await api.patch("/profile/me/slug", { slug: value.replace(/^-+|-+$/g, "") });
      setValue(data.slug);
      onChange(data.slug);
      toast.success(`Your profile address is now ${host}/${data.slug}`);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} className="border border-white/10 border-t-0 p-6" data-testid="web-address-form">
      <p className="label-xs flex items-center gap-2"><Link2 size={12} /> Your profile address</p>
      {profile.slug_needs_choice && (
        <p className="text-sm text-primary mt-3" data-testid="web-address-taken-notice">The address with your name was already taken, so please choose your own below.</p>
      )}
      <div className="flex flex-col sm:flex-row gap-3 mt-3">
        <div className="flex items-center flex-1 border border-white/15 focus-within:border-primary">
          <span className="pl-3 text-white/50 text-sm whitespace-nowrap">{host}/</span>
          <Input value={value} onChange={(e) => { setValue(clean(e.target.value)); setError(""); }} className="border-0 focus-visible:ring-0 pl-1" data-testid="web-address-input" />
        </div>
        <button type="submit" disabled={saving || value === profile.slug} className="bg-primary text-primary-foreground px-5 py-2 text-xs font-bold uppercase tracking-wider disabled:opacity-40" data-testid="web-address-save">{saving ? "Saving…" : "Save address"}</button>
      </div>
      {error && <p className="text-sm text-red-400 mt-2" data-testid="web-address-error">{error}</p>}
      <p className="text-xs text-white/40 mt-2">Letters, numbers and dashes. Your old address keeps working and forwards to the new one.</p>
    </form>
  );
};
